/* eslint-disable react/forbid-prop-types */

import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import moment from 'moment';
import { Row, Col, Card, CardText, CardBody, CardTitle } from 'reactstrap';
import PropTypes from 'prop-types';
import LifeTimeValueChart from './LifeTimeValueChart';
import { sortByOptions } from '../../helper'


const LifeTimeValueShow = ({ dir, dataToShowForDatesSelected, monthsBetweenDates, title,
    categorisedBasedOn, viewReportButton,
    height, isSalesKey, currentlyShow  }) => {
        
        const categorisedBasedOnRef = useRef({ categorisedBasedOn });

        const [selectedOptions, setSelectedOptions] = useState([]) 
        const [sortBySelected, setSortBySelected] = useState(sortByOptions[1])
        const allCategories = {}
        const currentDataByCategory = {}; 
        const dataToPlot = [];         
      
        const changeFilter = (value) => {
            setSelectedOptions(value)
        };

        dataToShowForDatesSelected.forEach((item) => {
            const yearMonth = `${moment().month(item?.month).subtract(1, 'months').format('MMM')} ${item?.year}`;
            dataToPlot.push({
                OrderAt: yearMonth,
                firstOrder: item.firstOrder,
            })
        });
    
      
    return (
        <Col xs="12">              
                <Card className="pb-3 show-categ-daily-sales">
                <CardBody>
                <div className="card__title row align-items-center">
                        <h5 className="bold-text col-md-4">{title}</h5>                        
                        <div className="col-8" id="dvChartView">
                                    {viewReportButton?.()}
                                    </div>
                    </div>                                      
                        
                    {dataToPlot.length ? 
                    <LifeTimeValueChart dir={dir}
                                    dataToPlot={dataToPlot}
                                    height={275}
                                    showTitle={false}
                                    categorisedBasedOn={categorisedBasedOn}
                                    allCategories={allCategories}
                                    isSalesKey={isSalesKey}
                                    month={monthsBetweenDates}
                                />
                         : <div className="no-data">No data to display</div>}
                    </CardBody>
                </Card>           
           
        </Col>
    )
}

LifeTimeValueShow.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShowForDatesSelected: PropTypes.array.isRequired,
    monthsBetweenDates: PropTypes.array.isRequired,
    viewReportButton: PropTypes.func.isRequired,
    title: PropTypes.string,
    categorisedBasedOn: PropTypes.string,
    height: PropTypes.number.isRequired,
    isSalesKey: PropTypes.string,
    currentlyShow: PropTypes.object.isRequired,
}

LifeTimeValueShow.defaultProps = {
     title: 'Life Time Value By Month',
     categorisedBasedOn: 'productCategory',
     isSalesKey: 'amount'
 }

export default LifeTimeValueShow;